import React from "react";

function RouteIndicator(props) {
  const routeIcons =
    props.routeList && props.routeList.length
      ? props.routeList.map((route) => {
          const routeNumber = route.replace(/\D/g, "");
          const backgroundColour = props.routeColours.find((obj) => obj.RouteNo == routeNumber)
              ? props.routeColours.find((obj) => obj.RouteNo == routeNumber).PIDColour
            : "";
          const textColour = props.routeColours.find((obj) => obj.RouteNo == routeNumber)
            ? props.routeColours.find((obj) => obj.RouteNo == routeNumber).TextColour
            : "";
          return (
            <div
              className="route-indicator-item "
              style={{
                backgroundColor: backgroundColour,
                color: textColour,
              }}
              key={route}
            >
              <span>{route}</span>
            </div>
          );
        })
      : "";

  return <div className="route-indicator">{routeIcons}</div>;
}

export default RouteIndicator;
